import { IonContent, IonLoading, IonPage, useIonViewWillEnter } from '@ionic/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SOSContactList } from '../../components/sos-contacts/SOSContactList';
import { SosContactType, useRemoveSosContactMutation, useSosContactsQuery } from '../../generated/graphql';
import { ErrorNetwork } from '../../components/error/ErrorNetwork';
import { AddButton } from '../../components/UI/AddButton/AddButton';
import { Title } from '../../components/title/Title';

const SOSContactsPage: React.FC = () => {
  const { data, loading, error, refetch } = useSosContactsQuery({
    fetchPolicy: 'no-cache',
  });

  useIonViewWillEnter(() => {
    if (data) refetch();
  }, [data]);

  const { t } = useTranslation();

  const [removeSosContact, { loading: removeSosContactLoading }] = useRemoveSosContactMutation({
    onCompleted: () => {
      refetch();
    },
  });

  const handleRemoveSosContact = async (id: string) => {
    await removeSosContact({
      variables: {
        input: { id },
      },
    });
  };

  if (loading) {
    return <IonLoading isOpen message={t('Loading...')} />;
  }

  return (
    <IonPage>
      <Title
        translucent
        title={t('SOS Contacts')}
        menuButton
        sort={{
          sortButton: true,
          callback: () => {},
        }}
      />
      <IonContent>
        {error ? (
          <ErrorNetwork error={error} />
        ) : (
          <>
            <SOSContactList
              removeSOSContact={handleRemoveSosContact}
              soscontacts={data?.sosContacts.edges.map((edge) => edge.node as SosContactType) || []}
            />
            <AddButton routeLink="/sos-contacts/new" />
          </>
        )}
      </IonContent>
      {!loading && removeSosContactLoading && <IonLoading isOpen message={t('Loading...')} />}
    </IonPage>
  );
};

export { SOSContactsPage };
